import React from 'react';
import { useState, useEffect, useFormContext, Hooks, Code, Form, Field, Name, Title, Actions, Toast, API, Utility, Button, Files, Control, Messages, OptionType } from 'helpers/FormImports';
import { Client, Invoice } from 'helpers/ImportModels';
import {  } from 'models/MergeModel';

const ClientMerge: React.FC = () => {
  const width = { id: 15, client: 35, dob: 20, age: 20 }
  const [formId, formName] = [Code.Form.Id.CLIENT, Code.Form.Name.CLIENT];
  const {keyId, activeId, setActiveId, loading, setLoading, message, setMessage, showMenu, setShowMenu, confirm, setConfirm, error, setError, menuPosition, setMenuPosition, contextMenuRef, iframeRef, formRef } = useFormContext();
  const [activeTab, setActiveTab] = useState<string>(Utility.Storage.GetTab("merge"));
  const [formData, setFormData] = useState<Client>({});
  const [selectedClientData, setSelectedClientData] = useState<Client>({});
  const [clientData, setClientData] = useState<Client[]>([]); 
  const [selectedClient, setSelectedClient] = useState<string | number | null | undefined>(undefined); 
  const [clientOptions, setClientOptions] = Hooks.Form.Options();

  const [invoiceData, setInvoiceData] = useState<Invoice[]>([]);
    
  Form.Click.Outside([contextMenuRef],[() => setShowMenu(false),() => {}],true);
  const Privilege = Hooks.Privilege.List(formId);
  Hooks.Privilege.HasOpen(Privilege);
  
  useEffect(() => {
     API.Data.GetByKeyId<Client>(formName, keyId, setLoading, setError)
      .then(async(data) => { if(data) {
        const formData = await Form.Map.Data(data);
        setFormData((prevData) => ({
          ...prevData,
          ...formData,
        }));
        callClientList(data.client_first_name, data.client_middle_name, data.client_last_name, data.client_phone, data.client_address);
      }})
      setLoading(false);
  }, []);


  useEffect(() => {
    if(clientData.length > 0) {
      console.log("Client Data fetched for merge:", clientData);
      const options = Utility.Convert.DataToOption(clientData, Name.Client.Id, [Name.Client.Number, Name.Client.FirstName, Name.Client.MiddleName, Name.Client.LastName, Name.Client.Address], Code.Option.Common.SELECT);
      setClientOptions(options.filter(option => option.value !== formData.client_id)); 
    }
  }, [clientData]);

  useEffect(() => {
    if (selectedClient) {
      console.log("Selected Client ID:", selectedClient);
    }
  }, [selectedClient]);

  const callClientList = async (
    clientFirstName: string | undefined,
    clientMiddleName: string | undefined,
    clientLastName: string | undefined,
    clientPhone: string | undefined,
    clientAddress: string | undefined,
  ) => {
      if (!clientFirstName || !clientPhone || !clientAddress) return;  
        const url = API.Build.FormApiEndpint(Code.Form.Name.CLIENT, 0, Name.Client.Id, Code.Option.Sort.ASC, {
        fields: Utility.Join.Fields([
          Name.Client.Id, 
          Name.Client.Number, 
          Name.Client.FullName, 
          Name.Client.Address, 
        ]),
        [Name.Client.FirstName]: clientFirstName,
        [Name.Client.MiddleName]: clientMiddleName,
        [Name.Client.LastName]: clientLastName,
        [Name.Client.Phone]: clientPhone,
        [Name.Client.Address]: clientAddress,
      });
      await API.Data.List<Client>(url, setClientData, setError, setLoading);
   };

   const mergeClients = async () => {
      const clientId1 = formData.client_id;
      const clientId2 = Number(selectedClient);
      console.log("Merging Clients:", clientId1, clientId2);
      if (clientId1 && clientId2) {
        const mergeResponse = await API.Data.MergeClient(clientId1, clientId2, setMessage);
      }
   };

  //  const mergeClients = async () => {
  //     if (selectedClient && formData.client_id) {
  //       let subItemList: string = "";
  //       const invoiceList = await callInvoiceList(selectedClient);
  //       subItemList = addSubItem("invoice", invoiceList, subItemList);

  //       console.log("Sub Item List for Merge:", subItemList);
       
  //       const addonData = await API.Data.AddonData({}, Code.Form.Name.MERGE, Code.Key.NEW, false);
  //       const finalData: Merge = {
  //         ...addonData,
  //         client_id1: formData.client_id,
  //         client_id2: Number(selectedClient),
  //         merge_data: `{${subItemList}}`,
  //       };

  //       console.log("Merge Data to be sent:", finalData);
          
  //       const mergeResponse = await API.Data.Save(Code.Form.Name.MERGE, Code.Key.NEW, finalData, setMessage)
  //       if(mergeResponse){
  //         const updatedData: Client = {
  //           client_active: Code.Option.Active.DELETE,
  //         };
  //         const updaterResponse = await API.Data.Save(formName, selectedClient, updatedData, setMessage)
  //         if(updaterResponse){
  //           Utility.Message.Info(["Selected client has been merged."],setMessage);
  //         }
  //       } else Utility.Message.Warning(["Please select client"],setMessage);
  //     }
  //  };

   const addSubItem = (key: string, value: string, subItemList: string): string => {
    if(value === "") return subItemList;
    if (!subItemList || subItemList.trim() === "") {
      subItemList = `\\"${key}\\":\\"${value}\\"`;
    } else {
      subItemList += `,\\"${key}\\":\\"${value}\\"`;
    }
    return subItemList;
  };


   const callInvoiceList = async (clientId: string | number): Promise<string> => {
      if (!clientId) return '';  
      const url = API.Build.FormApiEndpint(Code.Form.Name.INVOICE, 0, Name.Invoice.Id, Code.Option.Sort.DESC, {
        fields: Utility.Join.Fields([
          Name.Invoice.Id,
        ]),
        [Name.Client.Id]: clientId,
      });
      await API.Data.List<Invoice>(url, setInvoiceData, setError, setLoading);
      if (invoiceData && Array.isArray(invoiceData)) {
        const ids = invoiceData.map((item) => item['invoice_id']).filter(Boolean).join(",");
        return ids;
      }
      return '';
    };

  return (
    <Control.Form.Frame setMenuPosition={setMenuPosition} setShowMenu={setShowMenu}>
      <Messages.Toast Messages={message} Error={error} />
      {!loading && (
        <form id={Code.Form.Name.EDIT} ref={formRef}>
          <Button.Top formName='Merge' />
          <Control.Tab.Header titles={['Merge']} activeTab={activeTab} formName={"merge"} setActiveTab={setActiveTab} />
          <Control.Form.Data>
            <Control.Tab.Content id={Code.Tab.Tab1} isActive={activeTab === Code.Tab.Tab1}>
              <Control.Row>
                <Field.Select id={Name.Client.Id} value={selectedClient} title={'Selected duplicate client'} options={clientOptions}  onChange={(e) => setSelectedClient(Form.Field.Value(e))} require={true} />
              </Control.Row>
              <Control.Row className='tbleft'>
                <Button.Action title='Merge' info={'Click here to merge selected client into primary client'} onClick={mergeClients} />
              </Control.Row>
            </Control.Tab.Content>
          </Control.Form.Data>
        </form>
      )}
      <Actions.Form />
    </Control.Form.Frame>
  );
};

export default ClientMerge;